import axios from 'axios'
import Global from '@/global'

const initialState = () => ({
  friendsSelectedMembers: [],
  notFriendsSelectedMembers: [],
  selectedTreeOrgan: [],
  selectedCorps: [],
})

const state = initialState()

const getters = {
  treeDefaultCheckedVal(state) {
    return state.friendsSelectedMembers
      .map(el => el.id ? `uid|${el.id}` : `uid|${el.uid}`)
      .concat(state.selectedTreeOrgan)
  },
  selectedMembers(state) {
    return state.friendsSelectedMembers.concat(state.notFriendsSelectedMembers)
  }
}

const mutations = {
  setFriendsSelectedMembers(state, data) {
    state.friendsSelectedMembers = data
  },
  setNotFriendsSelectedMembers(state, data) {
    state.notFriendsSelectedMembers = data
  },
  setSelectedTreeOrgan(state, data) {
    state.selectedTreeOrgan = data
  },
  spliceFriendsSelectedMember(state, index) {
    state.friendsSelectedMembers.splice(index, 1)
  },
  spliceNotFriendsSelectedMember(state, index) {
    state.notFriendsSelectedMembers.splice(index, 1)
  },
  spliceSelectedCrop(state, index) {
    state.selectedCorps.splice(index, 1)
  },
  spliceSelectedTreeOrgan(state, index) {
    state.selectedTreeOrgan.splice(index, 1)
  },
  resetState (state) {
    const initial = initialState()
    Object.keys(initial).forEach(key => { state[key] = initial[key] })
  },
}

const actions = {
  queryUserInfo(_, uid) {
    return new Promise((resolve, reject) => {
      axios.get(`/hiapigw/app/user/someoneUserInfo?uid=${uid}&_id=` + Global.genNonce(5))
        .then(res => {
          if (res.data.code === 0) {
            const { avatar, userId: uid, email, name, mobile, nameSpell, corpId, corpName } = res.data.data.userInfo
            resolve({ avatar, corpId, corpName, email, mobile, name, nameSpell, uid })
          }
          reject(res.data.comment)
        })
        .catch(_ => {
          reject('app/user/someoneUserInfo接口调用失败')
        })
    })
  },
  getAllNotFriendsInfo({ commit, dispatch }, notFriendIds) {
    Promise.all(
      notFriendIds
        .map(el => dispatch('queryUserInfo', el.startsWith('uid|') ? el.split('|')[1] : el))
    )
      .then(res => {
        commit('setNotFriendsSelectedMembers', res)
      })
      .catch(err => {
        console.warn(err)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
